import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import { AppBar, Toolbar, Typography, Container, Backdrop, CircularProgress, Snackbar, IconButton } from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Logo from '../logo.png';
import Logo2 from '../logo3.png';

import { Redirect, Switch, Route } from 'react-router-dom';
import useBreakpoints from '../styles/useBreakpoints';
import useWindowDimensions from '../styles/useWindowDimensions';

import Login from './Login';
import PowerBI from './PowerBI';
import Copyright from './Copyright';

const API_DEFAULT = 'https://back-visualizacion-service-q2nhgfzuoq-uc.a.run.app';
const WORKSPACE_ID = '2d1e2976-c0c6-44ed-a49f-c76b6c0d4767';
const REPORT_ID = '9c4c5595-0820-4cd6-b1b9-c9a422883185';

const useStyles = makeStyles((theme) => ({
    title: {
        flexGrow: 1,
        fontWeight: 500
    },
    a: {
        height: 37.39,
        [theme.breakpoints.up('sm')]: {
            height: 45.89
        },
    },
    logo: {
        width: 110,
        [theme.breakpoints.up('sm')]: {
            width: 135
        },
        marginRight: theme.spacing(1.5)
    },
    logo2: {
        width: 78,
        marginBottom: -1,
        [theme.breakpoints.up('sm')]: {
            width: 94,
            marginBottom: -1
        },
        marginRight: theme.spacing(4)
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }
}));

function Main(props) {
    const { theme } = props;
    const classes = useStyles();
    const point = useBreakpoints();
    const paths = ['/inicio-sesion', '/visor'];
    const refPBI = useRef(null);
    const [pbiEmbed, setPbiEmbed] = useState({});
    // eslint-disable-next-line
    const { height, width } = useWindowDimensions(refPBI, pbiEmbed);

    const [auth, setAuth] = useState(localStorage.getItem('auth'));
    const [accessToken, setAccessToken] = useState(localStorage.getItem('token'));
    const [username, setUsername] = useState(localStorage.getItem('username'));
    const [errorsLogin, setErrorsLogin] = useState(Array(2).fill(false));

    const [showBackdrop, setShowBackdrop] = useState(false);
    const [snack, setSnack] = useState(false);
    const [severity, setSeverity] = useState('');
    const [message, setMessage] = useState('');

    function validateLogin(user, password) {
        let errorLogin = false;
        if (user === '') {
            errorLogin = true;
            errorsLogin[0] = true;
        }
        if (password === '') {
            errorLogin = true;
            errorsLogin[1] = true;
        }
        if (errorLogin) {
            setErrorsLogin([...errorsLogin]);
            setMessage('Existen campos sin diligenciar o con algún error.');
            setSeverity('error');
            setTimeout(() => { setSnack(true) }, 0);
        }
        else {
            login(user, password);
        }
    }

    async function login(user, password) {
        setShowBackdrop(true);
        const res = await fetch(`${API_DEFAULT}/users/auth`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                'username': user,
                'password': password
            })
        })
        res
            .json()
            .then(d => {
                setShowBackdrop(false);
                if (d['token']) {
                    rol(d['token'], user);
                }
                else {
                    setMessage('Los datos de usuario y contraseña son incorrectos.');
                    setSeverity('error');
                    setTimeout(() => { setSnack(true) }, 0);
                }
            })
    }

    async function rol(token, usuario) {
        const res = await fetch(`${API_DEFAULT}/users/roles`, {
            headers: { 'Authorization': `Token ${token}` }
        })
        res
            .json()
            .then(d => {
                if (d['roles'].includes('Administrador') || d['roles'].includes('Visor MiBanco CI')) {
                    localStorage.setItem('token', token);
                    localStorage.setItem('auth', true);
                    localStorage.setItem('username', usuario);
                    setUsername(usuario);
                    setAccessToken(token);
                    setAuth(true);
                }
                else {
                    setMessage('El usuario no está habilitado para usar esta aplicación.');
                    setSeverity('warning');
                    setTimeout(() => { setSnack(true) }, 0);
                }
            })
    }

    return (
        <div>
            <AppBar position='static'>
                <Toolbar>
                    <a className={classes.a} href={'https://www.centronacionaldeconsultoria.com/'}>
                        <img src={Logo} alt='logo-cnc' className={classes.logo} />
                    </a>
                    <a className={classes.a} href={'https://www.mibanco.com.co/#!inicio'}>
                        <img src={Logo2} alt='logo' className={classes.logo2}/>
                    </a>
                    <Typography style={{ marginRight: theme.spacing(2), color: 'inherit', textDecoration: 'none' }} variant='h5' className={classes.title}>
                    {
                            point !== 'xs' ?
                                point !== 'sm' ?
                                    'Evaluación Cliente Interno'
                                    :
                                    'E. Cliente Interno'
                                :
                                'ECI'
                        }

                    </Typography>
                    {
                        !auth ?
                            null
                            :
                            <React.Fragment>
                                <Typography style={{ display: point === 'sm' || point === 'xs' ? 'none' : null, fontWeight: 500, marginRight: theme.spacing(2) }} variant='body1'>{username}</Typography>
                                <IconButton edge='start' color='inherit' onClick={() => { localStorage.removeItem('token'); localStorage.removeItem('auth'); localStorage.removeItem('username'); setAccessToken(''); setAuth(false); setUsername(''); }}>
                                    <ExitToAppIcon />
                                </IconButton>
                            </React.Fragment>
                    }
                </Toolbar>
            </AppBar>
            <div style={{ marginTop: theme.spacing(2) }}>
                <Redirect
                    to={{ pathname: auth ? paths[1] : paths[0], state: { from: props.location } }}
                />
                <Switch>
                    <Route exact path={paths[0]}>
                        {
                            !auth ?
                                <Container component='main' maxWidth='xs'>
                                    <Login theme={theme} errors={[errorsLogin, setErrorsLogin]} validateLogin={validateLogin} />
                                </Container>
                                :
                                null
                        }
                    </Route>
                    <Route path={paths[1]}>
                        {
                            auth ?
                                <Container component='main' maxWidth='xl'>
                                    <PowerBI pbi={[pbiEmbed, setPbiEmbed]} refPBI={refPBI} width={width} theme={theme} accessToken={accessToken} API_DEFAULT={API_DEFAULT} WORKSPACE_ID={WORKSPACE_ID} REPORT_ID={REPORT_ID} setShowBackdrop={setShowBackdrop} />
                                </Container>
                                :
                                <Redirect to={paths[0]} />
                        }
                    </Route>
                </Switch>
            </div>
            <Copyright />
            <div>
                <Backdrop className={classes.backdrop} open={showBackdrop}>
                    <CircularProgress color='inherit' />
                </Backdrop>
                <Snackbar
                    open={snack}
                    autoHideDuration={6000}
                    onClose={() => setSnack(false)}
                >
                    <Alert onClose={() => setSnack(false)} severity={severity} variant='filled'>
                        {message}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    );
}

export default Main;